
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
	Consultant 
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Qualification & Experience : </h3>
                <p> <span class="step_no">1</span> 	Experience required: Minimum 8 years of professional experience which include minimum 3 years of relevant work experience</p>
				
               <p> <span class="step_no">2</span>Qualifications: Post graduate degree in Business Management, Social Science, Social Work, etc</p>
                
                
               <p> <span class="step_no">3</span> Any specific industry experience details (if applicable)
               </p>
               <p> <span class="step_no">4</span>Knowledge of methodologies for policy review and analysis and prior experience in entrepreneurship, livelihood development space is preferred</p>
               <p> <span class="step_no">5</span>Experience of working towards creation of/leading incubation centres. start-ups would be preferred  </p>
				<p> <span class="step_no">6</span>Experience in Policy facilitation, project management will be preferred. </p>
				<p> <span class="step_no">7</span>Special skill required (if applicable): Excellent with MS Office, Excel, Power Point</p>
				<p> <span class="step_no">8</span>Details of Competencies required for the position: Competency to perform advisory role, stakeholder management and policy analysis to support entrepreneurial division for MSDE</p>
				<p> <span class="step_no">9</span>Key Performance Indicators (KPIs):</p>
				<p>	•	Capacity to function as part of a multi disciplinary team.</p>
				<p>	•	Formulation of Project Proposals as per MSDE mandate</p>
				<p>	•	Pro-actively interact with key stake-holders, Ministries, State Governments, UN agencies, Corporate Sector etc. </p>
				

              </div>
            </div>
          </div>
          <!-- feature box close -->
  
       
  <!-- feature box begin -->
  <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Desirable:</h3>
        <p> <span class="step_no">E</span>	Full time MBA from recognized University/ Institute.</p>
        <p> <span class="step_no">F</span>	Aptitude in analyzing Questions </p> 
        <p> <span class="step_no">G</span>	Communication in multiple languages </p>
		<p> <span class="step_no">H</span>Knowledge of pedagogy and instructional material/Question bank development</p>
        <p> <span class="step_no">3</span>In-depth knowledge of Database Technologies, Architecture and Data security.</p>
		<p> <span class="step_no">4</span>Experience in Designing Logical / Physical Data Models and create Physical Databases for the Software Development Projects</p>
		<p> <span class="step_no">5</span>Experience in developing Functions and Triggers</p>
		<p> <span class="step_no">6</span>Experience in Management Information Systems (MIS)</p>
		
       </div>
    </div>
  </div>-->
  
  
  <!-- feature box close -->



  <!-- feature box begin -->
  <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Scope of Work:</h3>
        <p> <span class="step_no">1</span> 	Overall management of HR Policy, travel arrangements, grievance redressal, coordination and management.*</p>
        
        <p> <span class="step_no">2</span> 	Consultant should be well-versed with designing current and future estimations, procurement requirements, cost estimations and compliance requirements etc.</p>
        <p> <span class="step_no">3</span>	Consultant should be aware of compliances/policies related to managing finance and procurement of GoI/Ministry of Finance/World Bank or any other finding agencies.</p>
        <p> <span class="step_no">4</span> 	Coordination with the team and client including all the stakeholders and ensure all project deliverables are submitted within stipulated time and ensure high quality deliverables.</p>
        <p> <span class="step_no">5</span> 	Liaising and stakeholder management (including officials in states/districts and various other stakeholder representatives)</p>
        <p> <span class="step_no">6</span> 	Able to work independently  in a self guided mode and solve  problems </p>
        <p> <span class="step_no">7</span> 	Strong time management, organizational, planning and follow-up skills; ability to multi-task effectively. Ability to cope well under pressure and meet deadlines. Problem-solving and the ability to use the information to generate creative solutions.</p>
		<p> <span class="step_no">2</span> Strong in knowledge in implementing Functions and Triggers</p>
        <p> <span class="step_no">3</span> Database : My Sql / SQL Server / Oracle / Mongo DB / Postgres SQL</p>
		<p> <span class="step_no">4</span> Experience in PHP My Admin</p>
        <p> <span class="step_no">5</span> Experience in working with agile methodologies. </p>
       </div>
    </div>
  </div>-->
  <!-- feature box close -->



  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 50,000/-  to 2,00,000/-   </p>
		<!--<p> <span class="step_no">2</span> Rs. 1,00,000/- per month (consolidated pay) for 3+ Experience from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.  </p>-->


      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Scope of work :</h3>
        <p> <span class="step_no">1</span>Support design of entrepreneurship programmes /policies based on framework defined by MSDE </p>
        <p> <span class="step_no">2</span>Manage and facilitate entrepreneurship initiatives of Ministry and provide support to the Ministry in planning and implementing schemes and programs supporting grassroots social enterprises, skill based entrepreneurship, self-employment, etc. along with building the entrepreneurship ecosystems </p>
        <p> <span class="step_no">3</span>Support the ENP division of Ministry in entrepreneurship related content and curriculum development, concept notes, analytical reports and other project and policy documents, research studies, evaluations, assessments, data collection and report development </p>
        <p> <span class="step_no">4</span>To conduct regular review of various programs/projects and facilitate meetings/interactions with various stakeholder</p>
        <p> <span class="step_no">5</span> Explore lucrative partnerships with corporate, NGO’s, Foundations, Academic institutions, Development Organisations to strengthen the entrepreneurial ecosystem for entrepreneurship education, digital networks, mentors and mentor agencies, etc </p>
		<p> <span class="step_no">6</span>Coordinate with relevant stakeholders (national and state governments, multi-lateral partners, funding agencies, non-profits, think-tanks, and industry players) with an aim of improving project outcomes</p>
        <p> <span class="step_no">7</span>Closely work with NIESBUD, HE and other state Institutes and agencies for entrepreneurship promotion among skilled youth</p>
        <p> <span class="step_no">8</span>Liaison and support State Skill Missions (SSM) to take up entrepreneurship intervention pan India</p>
        <p> <span class="step_no">9</span> Planning and coordination of innovation events, trainings, national awards, workshops, conferences, visits, and exchange programme etc.</p>
        
      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Age</h3>
        <p><span class="step_no">1</span>Chennai</p>-->
		<!--<p>Up to 35 years</p>
	
      </div>
    </div>
  </div>-->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 17th July 2022 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Period of Contract </h3>
        <!--<p><span class="step_no">1</span>Chennai</p>-->
		<p>The appointment to the post will be purely on contract basis initially for a period of one year, further extendable subject to satisfactory performance and requirement of services for another year. The performance of the consultant will be reviewed every year and the contract shall be extended or discontinued (as the case may be) depending on the performance. The decision of NIMI shall be final in this regard.</p>
	
      </div>
    </div>
  </div>

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p><span class="step_no">1</span>Delhi </p>
		<!--<p><span class="step_no">1</span>04 (Four)at NIMI, Chennai</p>-->
	
      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Short listed candidates will be called for Computer test followed by Interview. </p>
        <!--<p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee.</p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
        <p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>-->

      </div>
    </div>
  </div>
  <!-- feature box close -->
  
     <!-- feature box begin -->
  <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
		<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority. </p>


      </div>
    </div>
  </div>-->
  <!-- feature box close -->
  
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  
<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>







